<template>
  <div class="wrap">
    <div class="contents_wrap type2">
      <section>
        <div class="login_box">
          <div class="left">
            <div class="login_logo">
              <h1>AICC Service</h1>
              <span>{{ $store.getters.contactCenterName }}</span>
            </div>
          </div>
          <div class="right">
            <h2>환영합니다! 로그인하세요</h2>
            <div class="form_box">
              <div class="hbox jc">
                <ur-text-field v-model="loginId" placeholder="이메일 (email@address.com)" width="100%" ref="loginId"/>
              </div>
              <div class="hbox jc">
                <ur-text-field type="password" v-model="password" placeholder="비밀번호" @keyup.enter="doLogin" width="100%" ref="password" />
              </div>
              <div class="keep_check">
                <ur-checkbox v-model="rememberId">사용자 기억하기</ur-checkbox>
                <a @click="gotoFindPasswordPage" class="btn_forget">비밀번호를 잊어버리셨나요?</a>
              </div>
              <ur-button class="btn_login" :disabled="isDisabledBtn" @click="doLogin" width="100%">로그인</ur-button>
            </div>
          </div>
        </div>
      </section>
      <!-- Password Expire Confirm Modal -->
      <ur-modal ref="confirmModal" :title="'확인'" small @closed="gotoChangePasswordPage()" >
        <template>
          {{message}}
        </template>
        <template slot="action">
          <ur-button shape="solid" primary @click="confirm()" >확인</ur-button>
        </template>
      </ur-modal>
    </div>
  </div>
</template>

<script>
import ERROR_TYPE from '~common/js/error-type.js';
import AuthManager from '~system/auth/AuthManager';
import '~assets/css/aicc/home.css';/* css 파일 내 home_footer class 스타일을 가져오기 위한 import  */
import ReplyCode from '~modules/AI/js/ReplyCode.js';

export default {
  name: 'Login',
  data() {
    return {
      ccUrl: '',
      loginId: '',
      password: '',
      rememberId: false,
      loadingFlag: false,

      // confirm modal
      message: '',
    };
  },
  computed: {
    // 로그인 버튼 비활성화 여부
    isDisabledBtn() {
      if (this.password.length === 0 || !utils.isEmailFormat(this.loginId) || this.loadingFlag) {
        return true;
      }
      return false;
    },
  },
  mounted() {
    this.$store.commit('hideGnbMenu');
    this.$store.commit('showFooter');
    if (localStorage.getItem('loggedInId')) { // ID가 저장되어 있을 때
      this.loginId = localStorage.getItem('loggedInId');
      this.rememberId = true;
      this.$refs.password.focus();
    } else {
      this.$refs.loginId.focus();
    }
  },
  methods: {
    // 로그인
    doLogin() {
      // validation check
      if (this.isDisabledBtn) {
        return;
      }
      this.loadingFlag = true; // 로그인 버튼 비활성화

      if (this.rememberId) { // ID 저장
        localStorage.setItem('loggedInId', this.loginId);
      } else {
        localStorage.removeItem('loggedInId');
      }

      this.ccUrl = aiccUtils.urlUtil.getCcUrl();

      AuthManager.encrypt(this.password).then(encryptedPassword => { // 평문 비밀번호를 암호화
        const loginAsk = {
          ccUrl: this.ccUrl,
          loginId: this.loginId,
          encryptedPassword,
        };

        AuthManager.loginDirectly(loginAsk).then(loginData => {
          if (loginData.reply.code === ReplyCode.NO_ERROR) { // 로그인 성공
            this.$router.go(); // default 화면 이동을 위한 새로고침 -> newPortal/main.js 실행
          } else { // 로그인 실패
            this.loadingFlag = false; // 로그인 버튼 활성화
            utils.aiccMessageBox('확인', loginData.reply.korMsg, '확인');
          }
        }).catch(err => { // 로그인 실패
          this.loadingFlag = false; // 로그인 버튼 활성화

          if (err.errorType) {
            if (err.errorType === ERROR_TYPE.LOGIN) { // 정의된 로그인 오류인 경우
              if (err.code === ReplyCode.LOGIN_PW_NOT_MATCH_5) { // 비밀번호 실패 5회 이상
                utils.aiccMessageBox('확인', err.errorMessage, '확인', this.gotoFindPasswordPage);
              } else if (err.code === ReplyCode.LOGIN_PW_EXPIRED) { // 비밀번호 만료
                this.$store.commit('setPasswordExpired', true); // 새로고침 또는 비정상적인 방법으로 만료 비밀번호 변경 화면으로 접속하는 것을 방지하기 위함
                this.openConfirmModal(err.errorMessage);
              } else {
                utils.aiccMessageBox('확인', err.errorMessage, '확인');
              }
            } else {
              utils.aiccMessageBox('확인', err.errorMessage, '확인');
            }
          } else {
            console.warn(err);
          }
        });
      });
    },

    // 비밀번호 만료 확인 팝업
    openConfirmModal(message) {
      this.message = message;
      this.$refs.confirmModal.open();
    },

    // 비밀번호 만료 확인 팝업 -> 확인 버튼
    confirm() {
      this.$refs.confirmModal.close();
    },

    // 만료 비밀번호 변경
    gotoChangePasswordPage() {
      utils.goPage('/ChangePassword');
    },

    // 비밀번호 찾기
    gotoFindPasswordPage() {
      utils.goPage('/FindPassword');
    },
  },
};
</script>

<style scoped>
/* ======== container ========= */
.wrap {background-color:#f7f7f7; display: flex; justify-content: center; align-items: center;}

/* ========== button ========== */
.login_box .btn_login {display: block; width: 100%; height: 48px;line-height: 46px; margin-top:24px; background-color:#516af4; font-size: 18px; color:#fff; text-align: center; border: none;}
.login_box .btn_login:hover {background-color:#516af4;}
.login_box .ur-button--disabled {background-color: #f7f7f7 ;color:#a5a5a5;}
</style>
